import React from "react";
import { connect } from "react-redux";
import ParticipantsLabel from "./ParticipantsLabel";
import Participants from "./Participants";
import DirectChat from './DirectChat/DirectChat';

const ParticipantsSection = ({ isRoomHost, roomId, socketId, participants }) => {
  return (
    <div className="participants_section_container" style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: '#181818'
    }}>
      <ParticipantsLabel count={participants?.length || 0} />
      <Participants
        isRoomHost={isRoomHost}
        roomId={roomId}
        currentUserSocketId={socketId}
      />
      <DirectChat />
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    participants: state.participants,
    socketId: state.socketId,
  };
};

export default connect(mapStoreStateToProps)(ParticipantsSection);
